

































import { Component, Prop, Vue } from 'vue-property-decorator'
import { PrepArea, ProductionPrepArea, ProductionPrepAreaSummary } from '@/models'

/**
 * Collapsible area of the preparation catalog, of a preparation or of its summary. Editable, it
 * has a menu to add a task, edit or remove the area. The icon, the summary, the header buttons
 * and the content come from the parent.
 */
@Component
export default class PrepAreaCard extends Vue {
  @Prop({ required: true }) area: PrepArea | ProductionPrepArea | ProductionPrepAreaSummary
  @Prop({ default: true }) open: boolean
  // Without content to show it is just the header
  @Prop({ default: true }) collapsible: boolean
  @Prop({ default: true }) editable: boolean
  @Prop({ default: false }) muted: boolean
}
